import axios from '@/libs/axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchPerfilAcessos(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/perfilAcesso/findAll', { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchPerfilAcesso(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/perfilAcesso/findOne/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    addPerfilAcesso(ctx, perfilData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/perfilAcesso/create', perfilData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    putPermissoesPerfilAcesso(ctx, { id, allPermissao }) {
      console.log(id, allPermissao);
      return new Promise((resolve, reject) => {
        axios
          .put(`/perfilAcesso/updatePermissoes/${id}`, allPermissao)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    putPerfilAcesso(ctx, perfilData) {
      return new Promise((resolve, reject) => {
        axios
          .put('/perfilAcesso/update', perfilData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    removePerfilAcesso(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/perfilAcesso/delete/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchPermissoes(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get('/permissao/findAll')
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
